import React from "react"

const BrandTable = props => {

    const {brands} = props

    /**
     * Sorts brands alphabetically, then groups into an object
     *
     * @param brands
     * @returns {*}
     */
    function sort_and_group_brands(brands) {
        let sorted_brands = brands.sort((a, b) => {
            return (a.name.toUpperCase() > b.name.toUpperCase()) ? 1 : -1
        })
        // Remove duplicates
        sorted_brands = [...new Set(sorted_brands)]
        return sorted_brands.reduce((groups, item) => {
            const firstLetter = item.name.toUpperCase().charAt(0)
            if (!(firstLetter in groups)) {
                groups[firstLetter] = []
            }

            groups[firstLetter].push(item)

            return groups
        }, {})
    }
    let grouped_and_sorted_brands = sort_and_group_brands(brands)

    return (
        <div className={`brands-sorted`}>
            {Object.keys(grouped_and_sorted_brands).map(letter => {
                return (
                    <div className={`brands-group`} key={letter}>
                        <h3>{letter.toUpperCase()}</h3>
                        {grouped_and_sorted_brands[letter].map((brand) => {
                            return (
                                <a key={brand.name} href={ brand.url === `#` ? `/collections/all-equipment/make:${ brand.name.replace(` `, `-`) }` :  brand.url }>
                                    { brand.name }
                                </a>
                            )
                        })}
                    </div>
                )
            })}
        </div>
    )
}

export default BrandTable
